import keycloakAxios from '@/services/axios';

export const fetchOtherUserData = async (userId: string) => {
  const response = await keycloakAxios.get(`user/other/${userId}`, {});

  if (response.status >= 300) {
    throw new Error(
      `Error fetching other user data: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
